import React from 'react';
import * as R from 'ramda';
import Form, { DisplayField } from 'common/mdc/form';
import { injectIntl, intlShape, defineMessages, FormattedMessage } from 'react-intl';
import { Link } from 'found';
import { NodeLink } from '@sma/components/node';
import DeviceShape from '@sma/components/device/shape';
import AddOn from './addOns';
import { connect } from "react-redux";
import {
  TableActionCell,
} from "common/mdc/table";
import Menu, { MenuItem } from "common/mdc/menu";
import { compose } from 'redux';
import Dialog, { withConfirmationDialog } from 'common/mdc/dialog';
import { actions as tagActions } from "@sma/store/tag/tags";
import AttachTagDialog from './attachDialog/attachTagDialog';
import { actions as deviceSearchActions } from '@sma/store/device/search';
import { actions as deviceActions } from "@sma/store/device/devices";
import { isC4 } from './table';

const messages = defineMessages({
  deviceId: {
    id: 'device.field.deviceId',
    defaultMessage: 'Meter ID',
  },
  nodeId: {
    id: 'device.field.address',
    defaultMessage: 'Address',
  },
  vendor: {
    id: 'device.field.vendor',
    defaultMessage: 'Vendor',
  },
  firmware: {
    id: 'device.field.firmware',
    defaultMessage: 'Firmware',
  },
  hardware: {
    id: 'device.field.hardware',
    defaultMessage: 'Hardware',
  },
  driver: {
    id: 'device.field.driver',
    defaultMessage: 'Driver',
  },
  meteringProfiles: {
    id: 'device.field.meteringProfiles',
    defaultMessage: 'Metering profiles',
  },
  registers: {
    id: 'device.field.registers',
    defaultMessage: 'Registers',
  },
  addOns: {
    id: 'device.field.addOns',
    defaultMessage: 'AddOns',
  },
  alarms: {
    id: 'device.field.alarms',
    defaultMessage: 'Alarms',
  },
  detachTag: {
    id: 'device.dialogs.detachingTag',
    defaultMessage: 'Are you sure, you want to detach?',
  },
  latitude: {
    id: 'device.field.latitude',
    defaultMessage: 'Latitude',
  },
  longitude: {
    id: 'device.field.longitude',
    defaultMessage: 'Longitude',
  },
  altitude: {
    id: 'device.field.altitude',
    defaultMessage: 'Altitude',
  },
});

const getAttachedTags = (
  attachedTagsList,
  deviceId,
  detachDialog,
  detachAction,
  detachedTagsList,
  advancedToggleExpanded,
  toggleAdvancedSearch,
  clearCriteria,
  addCriteria,
  devicesFilterByTag,
  setValue,
  applyCriteria,
) => {
  const handleTagFilter = (namespace, label, tagId) => {
    advancedToggleExpanded ? null : toggleAdvancedSearch();
    clearCriteria();
    addCriteria({
      property: "tagId",
      nullable: true,
      type: "plain",
      label:{
        key: null,
        ref: null,
        props: {
          id: "meter.search.advanced.tags",
          defaultMessage: "Tags"
        }
      }
    });
    devicesFilterByTag(`${namespace}:${label}`);
    setValue({
      nullable: true,
      property: "tagId",
      type: "plain",
      constraints:[{operator: "=", value: tagId}],
    }, 0, tagId);
    applyCriteria({
      nullable: true,
      property: "tagId",
      type: "plain",
    });
  }
  if (attachedTagsList !== undefined && attachedTagsList.length > 0) {
    // to remove if any duplicates
    const ids = attachedTagsList.map((obj)=>parseInt(obj.tagId));
  attachedTagsList = attachedTagsList.filter((tag, index)=>ids.indexOf(parseInt(tag.tagId)) === index);
    return (
      <div className="tags-list">
        {attachedTagsList.map((tag) => {
          if (!detachedTagsList.includes(tag.tagId)) {
            return (
              <span
                key={tag.tagId}
                className="tag-pill"
                title={`${tag.namespace} - ${tag.label}`}
              >
                <span className="n_space"> {tag.namespace} </span>
                <span className="label">
                  {" "}
                  {tag.label}
                  <TableActionCell>
                    <Menu>
                      {tag.type === "SYSTEM" ? (
                        <MenuItem
                          onClick={() =>
                            detachDialog({
                              resolve: () =>
                                detachAction({
                                  meters: [deviceId],
                                  tags: [tag.tagId],
                                }),
                            })
                          }
                        >
                          Detach
                        </MenuItem>
                      ) : (
                        <MenuItem
                          onClick={() =>
                            detachAction({
                              meters: [deviceId],
                              tags: [tag.tagId],
                            })
                          }
                        >
                          Detach
                        </MenuItem>
                      )}

                        <MenuItem onClick={()=>handleTagFilter(tag.namespace, tag.label, tag.tagId)}>
                          <Link to={`/devices`} style={{ textDecoration: "none", color: "inherit" }}> View </Link>
                        </MenuItem>

                    </Menu>
                  </TableActionCell>
                </span>
              </span>
            );
          }
        })}
      </div>
    );
  }
  return null;
};

const DetailsForm = ({ device, displayDeviceLink, intl, detachDialog, detachAction, detachedTagsList, showAttachTagDialog, openAttachDialog, newlyAttachedTagsList,
  advancedToggleExpanded,
  toggleAdvancedSearch,
  clearCriteria,
  addCriteria,
  devicesFilterByTag,
  setValue,
  applyCriteria,
  geoLocation,
 }) => (
  <div className="device-details-pane">
    <Form style={{ padding: 0 }}>
      <DisplayField label={intl.formatMessage(messages.deviceId)}>
        {displayDeviceLink ?
          <Link to={`/devices/${encodeURI(device.deviceId)}`}>
            {device.deviceId}
          </Link> :
          device.deviceId
        }
      </DisplayField>
      <DisplayField label={intl.formatMessage(messages.nodeId)}>
        {device.nodeId == null ? null : (
          <NodeLink nodeId={device.nodeId} deviceId={device.deviceId} terminalReferenceId={device.terminalReferenceId}
            isC4={isC4(device.nodeId)}
          >
            {isC4(device.nodeId) ? `c4/${device.nodeId}/${device.deviceId}` : `dcs/${device.deviceId}`}
          </NodeLink>
        )}
      </DisplayField>
      <DisplayField label={intl.formatMessage(messages.vendor)}>
        {device.vendor}
      </DisplayField>
      <DisplayField label={intl.formatMessage(messages.firmware)}>
        {device.firmwareVersion}
      </DisplayField>
      <DisplayField label={intl.formatMessage(messages.hardware)}>
        {device.hardwareVersion}
      </DisplayField>
      <DisplayField label={intl.formatMessage(messages.driver)}>
        {device.driver}
      </DisplayField>
      <DisplayField label={intl.formatMessage(messages.latitude)}>
        {geoLocation.latitude}
      </DisplayField>
      <DisplayField label={intl.formatMessage(messages.longitude)}>
        {geoLocation.longitude}
      </DisplayField>
      <DisplayField label={intl.formatMessage(messages.altitude)}>
        {(geoLocation.altitude !== null && geoLocation.altitude !== undefined) ? `${geoLocation.altitude} meters` : null}
      </DisplayField>
      {device.alarms && (
        <DisplayField label={intl.formatMessage(messages.alarms)} style={{ alignItems: 'start' }}>
          {device.alarms.length}
        </DisplayField>
      )}
      <DisplayField label={intl.formatMessage(messages.meteringProfiles)}>
        {device.meteringProfiles}
      </DisplayField>
      <DisplayField label={intl.formatMessage(messages.registers)}>
        {device.registers}
      </DisplayField>
      <DisplayField label={intl.formatMessage(messages.addOns)} style={{ alignItems: 'start' }}>
        {device.addOns && !R.isEmpty(device.addOns) && (
          <AddOn addOns={device.addOns} />)}
      </DisplayField>
      <DisplayField label="Tag(s)" style={{ alignItems: "start" }}>
        <div className="tag-more-action-btns">
        <Link to={`/devices/${encodeURI(device.deviceId)}/view-all-tags`} style={{textDecoration: 'none'}}>
          <button
            className="mdc-button mdc-button--raised view-all-attached-tags-btn"
            type="button"
          >
            view all
          </button>
        </Link>
          <button
            className="mdc-button mdc-button--raised"
            type="button"
            onClick={()=>openAttachDialog(true)}
          >
            attach
          </button>
        </div>
        <div className="meters-details_attached-tags-list">
          {getAttachedTags([...newlyAttachedTagsList, ...(device.tags === undefined ? [] : device.tags)],
            device.deviceId, detachDialog, detachAction, detachedTagsList,
            advancedToggleExpanded,
            toggleAdvancedSearch,
            clearCriteria,
            addCriteria,
            devicesFilterByTag,
            setValue,
            applyCriteria,
          )}
        </div>
      </DisplayField>
    </Form>
    { showAttachTagDialog ? <AttachTagDialog deviceId={device.deviceId} /> : null }
  </div>
);

const DetachDialog = ({ buttons, onClose }) => (
  <Dialog
    title={"Detach Tag?"}
    buttons={buttons}
    onClose={onClose}
  >
    <FormattedMessage {...messages.detachTag} />
  </Dialog>
);

DetachDialog.propTypes = {};

DetailsForm.propTypes = {
  device: DeviceShape.isRequired,
  intl: intlShape.isRequired,
};

export default compose(
  connect(
    (state) => {
      return {
        detachedTagsList: state.tags.detachedTagsList,
        showAttachTagDialog: state.tags.attachTag.showDialog,
        newlyAttachedTagsList: state.tags.newlyAttachedTagsList,
        advancedToggleExpanded: state.device.search.expanded,
        geoLocation: state.device.device.geoLocation,
      };
    },
    {
      detachAction: tagActions.detach,
      openAttachDialog: tagActions.showAttchTagDialog,
      toggleAdvancedSearch: deviceSearchActions.toggleExpand,
      addCriteria: deviceSearchActions.addCriteria,
      devicesFilterByTag: deviceActions.devicesFilterByTag,
      setValue: deviceSearchActions.setValue,
      clearCriteria: deviceSearchActions.clear,
      applyCriteria: deviceSearchActions.applyCriteria,
    }
  ),
  injectIntl,
  withConfirmationDialog(DetachDialog, 'detachDialog'),
)(DetailsForm);
